
import { defineComponent } from "vue";
import { trans } from "@/globals/translator";
import BlockTitle from "@/components/common/BlockTitle.vue";
import Grid from "@moonlight/vue3/components/Grid.vue";
import Row from "@moonlight/vue3/components/Row.vue";
import Col from "@moonlight/vue3/components/Col.vue";
import Button from "@moonlight/vue3/components/Button.vue";
import ButtonText from "@moonlight/vue3/components/button/ButtonText.vue";
import ButtonIcon from "@moonlight/vue3/components/button/ButtonIcon.vue";
import PosterCard from "@/components/media/PosterCard.vue";
import PosterCardSkeleton from "@/components/media/PosterCardSkeleton.vue";
import useHomeContent from "@/composables/useHomeContent";

export default defineComponent({
  components: {
    BlockTitle,
    Grid,
    Row,
    Col,
    Button,
    ButtonText,
    ButtonIcon,
    PosterCard,
    PosterCardSkeleton,
  },
  setup() {
    const { fetch, cineMedias, requestState } = useHomeContent();

    if (!cineMedias.value.length) {
      fetch();
    }

    return {
      trans,
      cineMedias,
      requestState,
    };
  },
});
